export default {
  methods: {

    draw_Header() {
      
      let head = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.y})`)

      // Draw Header
      this.columns.forEach((d,i)=> {
        head
        .append('text')
        .attr('x', d.mx)
        .attr('y', this.header.tSize*0.4)
        .style('font-size', this.header.tSize).style('fill', this.header.tColor)
        .attr('text-anchor', 'middle')
        .text(d.name)
      })

      let prog = this.columns.find(f=> f.code == 'ACTIVE')
      let grid_y1 = this.table.y - this.table.lineHeight - this.header.y 
      let grid_y2 = this.table.y + (this.rawData.length-1) * this.table.lineHeight - this.header.y 

      head
      .append('text')
      .attr('x', prog.sx).attr('y', this.header.height + 2)
      .style('font-size', 8).style('fill', '#bcbcbc').attr('text-anchor', 'middle')
      .text(0)

      head
      .append('text')
      .attr('x', prog.mx).attr('y', this.header.height + 2)
      .style('font-size', 8).style('fill', '#bcbcbc').attr('text-anchor', 'middle')
      .text(this.table.maxValue/2)

      head
      .append('text')
      .attr('x', prog.ex).attr('y', this.header.height + 2)
      .style('font-size', 8).style('fill', '#bcbcbc').attr('text-anchor', 'middle')
      .text(this.table.maxValue)

      // Grid Lines
      head
      .append('line')
      .attr('x1', prog.sx).attr('y1', grid_y1).attr('x2', prog.sx).attr('y2', grid_y2)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.2)

      head
      .append('line')
      .attr('x1', prog.mx).attr('y1', grid_y1).attr('x2', prog.mx).attr('y2', grid_y2)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.2)

      head
      .append('line')
      .attr('x1', prog.ex).attr('y1', grid_y1).attr('x2', prog.ex).attr('y2', grid_y2)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.2)
    },
    
  }
}